import { useAttachmentFieldCommit as useSharedFieldCommit } from '@features/Attachments/hooks/useAttachmentFieldCommit';
import { translate } from '@utils/i18n';
import { EDIT_MODAL_ERRORS_NS, INSPECTION_ATTACHMENTS_ENTITY_KEY } from '../constants';
import { updateInspectionAttachment } from '../services/inspectionAttachmentsApi';
/**
 * Inspection's binding of the shared single-field commit: pins the entity key and the PATCH
 * endpoint so the inline cells stay free of both.
 */
export function useAttachmentFieldCommit(inspectionId, attachmentId) {
    return useSharedFieldCommit({
        entityKey: INSPECTION_ATTACHMENTS_ENTITY_KEY,
        ownerId: inspectionId,
        attachmentId,
        update: updateInspectionAttachment,
        genericErrorMessage: translate('generic', { namespace: EDIT_MODAL_ERRORS_NS })
    });
}
